<div class="flex flex-col ">
    <div class="mb-8">
        @if (id != undefined) {
        <app-header [id]="id" [shareSocialMediaData]="{type: 'auction', id:id}"></app-header>
        }
    </div>


    <div id="item-list-container" class="container mx-auto mt-6 lg:px-20 min-h-auto">
        <div class="flex flex-col lg:flex-row justify-between mb-3 mx-4 sm:mx-0">
            <h2 class="text-[24px] mb-3">All Items</h2>

            <auctions-items-search-bar [originalQuery]="query()" (searchRequested)="onSearch($event)" />
        </div>

        <!-- Mobile category toggle — only when category list feature is enabled -->
        @if (isItemCategoryListEnabled()) {
            <div class="md:hidden mx-4 sm:mx-0 mb-4">
                <button (click)="toggleMobileCategoryPanel()"
                    class="w-full flex justify-between items-center h-11 px-4 border border-gray-200 rounded-lg bg-white text-[15px] font-semibold cursor-pointer"
                    style="color: var(--p-info-500)">
                    <span>Categories{{ mobileCategoryLabel() }}</span>
                    <span class="text-xs text-gray-500">{{ mobileCategoriesOpen() ? '▲' : '▼' }}</span>
                </button>
                @if (mobileCategoriesOpen()) {
                    <div class="border border-gray-200 rounded-lg bg-white -mt-2 overflow-hidden">
                        <!-- View All Items -->
                        <button (click)="viewAllItems()"
                            class="w-full flex items-center px-4 py-3 border-t border-gray-200 text-sm text-left cursor-pointer font-bold"
                            [style.background-color]="!filters().categoryId.length && !filters().dynamicCategory ? 'var(--p-primary-500)' : '#fff'"
                            [style.color]="!filters().categoryId.length && !filters().dynamicCategory ? 'white' : 'var(--p-info-500)'">
                            View All Items ({{ baseItemCount() || totalItemsSignal() }})
                        </button>
                        <!-- Smart Categories (non-Closed) -->
                        @for (cat of sidebarSmartCategories(); track cat.value) {
                            <button (click)="selectDynamicFromSidebar(cat.value)"
                                class="w-full flex items-center px-4 py-3 border-t border-gray-200 text-sm text-left cursor-pointer font-bold"
                                [style.background-color]="filters().dynamicCategory === cat.value ? 'var(--p-primary-500)' : '#fff'"
                                [style.color]="filters().dynamicCategory === cat.value ? 'white' : 'var(--p-info-500)'">
                                {{ cat.label }}
                            </button>
                        }
                        <!-- Regular Categories (count > 0) -->
                        @for (cat of sidebarRegularCategories(); track cat.value) {
                            <button (click)="selectCategoryFromSidebar(cat.value)"
                                class="w-full flex items-center px-4 py-3 border-t border-gray-200 text-sm text-left cursor-pointer"
                                [style.background-color]="filters().categoryId[0] === cat.value ? 'var(--p-primary-500)' : '#fff'"
                                [style.color]="filters().categoryId[0] === cat.value ? 'white' : 'var(--p-info-500)'">
                                {{ cat.label }}
                            </button>
                        }
                        <!-- Closed Items -->
                        @if (showClosedItems()) {
                            <button (click)="selectDynamicFromSidebar(closedItemsEntry()!.value)"
                                class="w-full flex items-center px-4 py-3 border-t border-gray-200 text-sm text-left cursor-pointer font-bold"
                                [style.background-color]="filters().dynamicCategory === closedItemsEntry()!.value ? 'var(--p-primary-500)' : '#fff'"
                                [style.color]="filters().dynamicCategory === closedItemsEntry()!.value ? 'white' : 'var(--p-info-500)'">
                                {{ closedItemsEntry()!.label }}
                            </button>
                        }
                    </div>
                }
            </div>
        }

        <!-- Main layout: sidebar + items when enabled, otherwise single column -->
        <div [class]="isItemCategoryListEnabled() ? 'flex flex-row gap-8 items-start' : ''">

            <!-- Sticky sidebar — desktop/tablet only, when enabled -->
            @if (isItemCategoryListEnabled()) {
                <aside class="hidden md:flex flex-col w-60 flex-none self-start sticky top-6 mt-4">
                    <nav class="flex flex-col">
                        <!-- View All Items -->
                        <button (click)="viewAllItems()"
                            class="sidebar-category-btn flex items-center px-3 py-2.5 rounded-md text-left cursor-pointer w-full text-sm font-bold"
                            [class.active]="!filters().categoryId.length && !filters().dynamicCategory">
                            View All Items ({{ baseItemCount() || totalItemsSignal() }})
                        </button>
                        <!-- Smart Categories (non-Closed) -->
                        @for (cat of sidebarSmartCategories(); track cat.value) {
                            <button (click)="selectDynamicFromSidebar(cat.value)"
                                class="sidebar-category-btn flex items-center px-3 py-2.5 rounded-md text-left cursor-pointer w-full text-sm font-bold"
                                [class.active]="filters().dynamicCategory === cat.value">
                                {{ cat.label }}
                            </button>
                        }
                        <!-- Regular Categories (count > 0) -->
                        @for (cat of sidebarRegularCategories(); track cat.value) {
                            <button (click)="selectCategoryFromSidebar(cat.value)"
                                class="sidebar-category-btn flex items-center px-3 py-2.5 rounded-md text-left cursor-pointer w-full text-sm"
                                [class.active]="filters().categoryId[0] === cat.value">
                                {{ cat.label }}
                            </button>
                        }
                        <!-- Closed Items -->
                        @if (showClosedItems()) {
                            <button (click)="selectDynamicFromSidebar(closedItemsEntry()!.value)"
                                class="sidebar-category-btn flex items-center px-3 py-2.5 rounded-md text-left cursor-pointer w-full text-sm font-bold"
                                [class.active]="filters().dynamicCategory === closedItemsEntry()!.value">
                                {{ closedItemsEntry()!.label }}
                            </button>
                        }
                    </nav>
                </aside>
            }

            <!-- Items area -->
            <div [class]="isItemCategoryListEnabled() ? 'flex-1 min-w-0' : ''">

                <div class="flex flex-col xl:flex-row justify-between mb-3 mx-4 sm:mx-0">

                    <div class="flex flex-col lg:flex-row gap-2 w-full lg:gap-2">

                        @if (!isItemCategoryListEnabled()) {
                            <p-multiSelect #categoryFilter [options]="categoryFilters()" [(ngModel)]="filters().categoryId"
                                (ngModelChange)="onCategoryChange($event)" (onChange)="hideOnMobile(categoryFilter)"
                                placeholder="Categories" display="chip" class="text-xs w-full lg:w-auto h-[35px] lg:mt-4 basis-1/4">
                            </p-multiSelect>
                        }

                        <div class="flex justify-between md:justify-normal gap-2 w-full lg:w-auto lg:mt-4">

                            @if (!isItemCategoryListEnabled()) {
                                <p-select [options]="dynamicCategories()" [(ngModel)]="filters().dynamicCategory"
                                    placeholder="Smart Categories"
                                    class="text-gray-400 w-full sm:w-1/4 lg:w-auto flex-shrink-0 text-xs"
                                    (ngModelChange)="onCategoryDynamicChange($event)">
                                </p-select>
                            }


                            <p-select [options]="sortFilters" [(ngModel)]="selectedSortSignal" placeholder="Sort by"
                                class="text-gray-400 w-full sm:w-1/4 lg:w-auto flex-shrink-0" (onChange)="onSortChange($event)">
                            </p-select>


                            <button pButton pRipple icon="pi pi-trash" class="p-button-outlined text-sm sm:w-1/4 lg:w-auto"
                                [style]="{ 'height': '35px', 'max-width': '100px' }" (click)="clearFilters()"></button>

                            <button pButton pRipple class="p-button-outlined text-sm lg:w-auto flex items-center gap-1"
                                [style]="{ 'height': '35px' }" (click)="openShareModal()">
                                <fa-icon [icon]="icons.faShareFromSquare" class="text-[14px]"></fa-icon>
                                <span class="hidden sm:inline text-[12px]">Share</span>
                            </button>
                        </div>
                    </div>


                    <div class="card justify-center hidden xl:flex lg:mt-4">
                        <p-selectbutton [options]="this.ItemListOptions" [(ngModel)]="viewMode" optionLabel="label" optionValue="value" allowEmpty="false" class="custom-p-selectbutton h-[37px] border-none ">
                            <ng-template #item let-item class="community-p-select-template">
                                <p-button [text]="item.value!=viewMode" class=" custom-p-button font-mulish" >
                                    <fa-icon class="text-[12px]" [icon]="item.value == 'image' ? icons.faImage : icons.faList"></fa-icon> <span class="whitespace-nowrap text-[12px]">{{item.label}}</span>
                                </p-button>
                            </ng-template>
                        </p-selectbutton>
                    </div>
                </div>

                <ng-container *ngIf="isLoadingListing() ; else content">
                    <div class="flex items-center justify-center min-h-[300px]">
                        <p-progress-spinner ariaLabel="loading" />
                    </div>
                </ng-container>

                <ng-template #content>
                    <div *ngIf="!showSearchView" class="container mx-auto pt-8">
                        <app-items [items]="itemList" [isHomePage]="false" [viewMode]="viewMode" [auctionId]="id"
                            (bidCompleted)="onBidCompleted()" (modalStatusChanged)="onModalStatusChanged($event)"></app-items>

                        <p-paginator [rows]="filters().per" [totalRecords]="totalItemsSignal()"
                            (onPageChange)="onPageChange($event)" [first]="firstSignal()"
                            [rowsPerPageOptions]="rowsPerPageOptions" styleClass="mt-7">
                        </p-paginator>
                    </div>
                    <div *ngIf="showSearchView">
                        <app-item-search [searchQuery]="searchQuery || ''"
                            [categoryName]="selectedCategoryName()"></app-item-search>
                    </div>
                </ng-template>

            </div>
        </div>
    </div>



    <p-dialog [(visible)]="showShareModal" [modal]="true" header="Share this view" [style]="{ width: '480px' }" [draggable]="false" [resizable]="false">
        <div class="flex flex-col gap-3 pt-1">
            <p class="text-sm text-gray-500">Copy the link below to share the current filters.</p>
            <div class="flex gap-2">
                <input pInputText [value]="shareableUrl()" readonly class="flex-1 text-xs min-w-0" />
                <button pButton pRipple icon="pi pi-copy" label="Copy" class="shrink-0 text-sm" (click)="copyShareableUrl()"></button>
            </div>
            <span class="text-green-600 text-sm font-medium" [class.invisible]="!linkCopied()">Link copied!</span>
        </div>
    </p-dialog>

    <div class="">
        <app-footer></app-footer>
    </div>
</div>
